import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
const steps = [{
  number: '01',
  title: 'Preparation',
  description: 'When you arrive for your treatment the targeted area is cleaned, and if necessary, a topical anesthetic may be applied to minimize discomfort.'
}, {
  number: '02',
  title: 'Laser Application',
  description: 'The handheld laser device is then applied to the skin, emitting pulses of light over the treatment area. The laser is adjusted based on factors like hair color, thickness and skin type.'
}, {
  number: '03',
  title: 'Cooling Measures',
  description: 'The Candela GentleMax Pro system incorporates cooling mechanisms to protect the surrounding skin and ensure your comfort during the procedure.'
}, {
  number: '04',
  title: 'Post-Treatment Care',
  description: 'After the session, you will be advised about post-treatment care, which may include avoiding sun exposure, using moisturizer and shaving/waxing.'
}];
export function LHHowItWorks() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1593">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1594">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1595">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-1596">
            Be MAGNIFICENT
          </span>

          <h2 className="text-[28px] lg:text-[44px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1597">
            HOW DOES LASER THERAPY WORK?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1598"></div>

          <p className="text-[#333333] text-[17px] leading-[1.7] font-body" data-id="element-1599">
            At Be CLINICAL, laser hair removal begins with a consultation, so we
            can assess your skin type, hair color and medical history. Then we
            create a customized plan just for you.
          </p>
        </AnimateOnScroll>

        <div className="space-y-0" data-id="element-1600">
          {steps.map((step, index) => <AnimateOnScroll key={index} delay={index * 100} data-id="element-1601">
              <div className={`py-10 ${index < steps.length - 1 ? 'border-b border-[#CCCCCC]' : ''}`} data-id="element-1602">
                <div className="flex items-start gap-6 lg:gap-10" data-id="element-1603">
                  <span className="text-[#F0D0E0] text-[60px] lg:text-[72px] font-[800] font-[Poppins,_sans-serif] leading-none opacity-30 select-none flex-shrink-0" data-id="element-1604">
                    {step.number}
                  </span>
                  <div className="pt-2" data-id="element-1605">
                    <h3 className="text-black text-[22px] font-bold font-[Poppins,_sans-serif] mb-3" data-id="element-1606">
                      {step.title}
                    </h3>
                    <p className="text-[#333333] text-base leading-[1.7] font-body" data-id="element-1607">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            </AnimateOnScroll>)}
        </div>

        <AnimateOnScroll delay={500} data-id="element-1608">
          <p className="italic text-[#666666] text-[15px] leading-[1.7] font-body mt-8 text-center" data-id="element-1609">
            Since hair grows in cycles and not all hair follicles are in the
            active growth phase simultaneously, multiple sessions are typically
            required to target hairs at different stages of growth.
          </p>
        </AnimateOnScroll>
      </div>
    </section>;
}